import * as React from 'react';
import styled, {css} from 'styled-components'
import {ConstBorderRound, ConstColor, ConstFontStyle, ConstPadding} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    hasError?: boolean;
    innerRef?: any;
    widthSize?: string;
}

const InputDefault: React.FC<IProps> = (props) => {

    const { children, hasError, innerRef, widthSize, ...InputProps } = props;

    return (<input {...InputProps} ref={innerRef}/>)

};

const FormInput = styled(InputDefault)`
    width: ${props => props.widthSize || "100%"};
    background: ${ConstColor.White};
    padding: ${ConstPadding.FormDefaultPadding};
    color: ${ConstColor.Base};
    // border
    border: 1px solid ${ConstColor.Gray};
    box-sizing: border-box;
    border-radius: ${ConstBorderRound.CornerRoundAll};
    // font
    font-style: normal;
    font-weight: ${ConstFontStyle.FormDefault.fontWeight};
    font-size: ${ConstFontStyle.FormDefault.fontSize};
    line-height: ${ConstFontStyle.FormDefault.lineHeight};
    &::placeholder {
        color: ${ConstColor.PlaceholderAndBorder};
    }
    &:read-only {
        background: ${ConstColor.Readonly};
        border: 1px solid ${ConstColor.Readonly};
    }
    &:disabled {
        background: ${ConstColor.Readonly};
        border: 1px solid ${ConstColor.Readonly};
    }
    &:focus {
        outline: 0;
        border: 1px solid ${ConstColor.Focus};
    }
    ${props => props.hasError && css`
      && {
          border: 1px solid ${ConstColor.Error};
          color: ${ConstColor.Error}
      }
    `}
`;

export default FormInput;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/form/form_input.tsx